import transitionEndEvent from '../animation/transitionEndEvent';
import addClickHandler from '../events/addClickHandler';
import toggleClass from '../elements/toggleClass';
import addStartupScript from '../events/addStartupScript';

export const navMenuTransitionEnd = function() {
  const navMenu = this;
  toggleClass(navMenu, 'js-header__nav--closed', false);
  navMenu.removeEventListener(transitionEndEvent(), navMenuTransitionEnd);
};

export const toggleOverlayClass = function(overlay, isActive) {
  const overlayActiveClass = 'js-header__overlay--active';
  if(isActive === true) {
    overlay.classList.remove(overlayActiveClass);
  } else {
    overlay.classList.add(overlayActiveClass);
  }
};

export const toggleNav = (navMenu, menuControl, overlay) => () => {
  const state = navMenu.dataset.state;
  const opposingState = state === 'closed' ? 'open' : 'closed';
  const overlayIsActive = overlay.classList.contains('js-header__overlay--active');
  navMenu.classList.remove('js-header__nav--' + state);
  navMenu.classList.add('js-header__nav--' + opposingState);

  const menuOpenClass = 'js-header-menu-control--open';

  state === 'closed' ? menuControl.classList.add(menuOpenClass) :
                       menuControl.classList.remove(menuOpenClass);

  toggleOverlayClass(overlay, overlayIsActive);

  navMenu.dataset.state = opposingState;
  navMenu.addEventListener(transitionEndEvent(), navMenuTransitionEnd);
};

export function setup() {
  const navMenu = document.querySelector('.js-header__nav');
  const overlay = document.querySelector('.header__overlay');
  if(navMenu){
    const menuControl = document.querySelector('.js-header-menu-control');
    addClickHandler(menuControl, toggleNav(navMenu, menuControl, overlay));
    // return true required for jest testing
    return true;
  }
  // return false required for jest testing
  return false;
}

addStartupScript(setup);
